export function useBranchingAnimation() {
  const stopBranchingAnimation = () => {
    const el = document.querySelector<HTMLElement>("[data-panel-group]");
    if (!el) return;

    el.style.transition = "";
    el.style.filter = "";
    el.style.opacity = "";
  };

  const startBranchingAnimation = () => {
    const el = document.querySelector<HTMLElement>("[data-panel-group]");
    if (!el) return;

    el.style.transition = "all 300ms ease-out";
    el.style.filter = "saturate(0)";
    el.style.opacity = ".25";
  };

  return {
    startBranchingAnimation,
    stopBranchingAnimation,
  };
}
